<div class="form-summary-compact">
  <div
    class="summary-header p-4 rounded-t-xl bg-gradient-to-br from-[#1a3a52] to-[#1a3a52]/90 text-white"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-white/20">
          <mat-icon class="!text-[24px] !w-6 !h-6">assignment_turned_in</mat-icon>
        </div>
        <div>
          <h1 class="text-lg font-bold text-white">{{ formName || 'Application Review' }}</h1>
          <p class="text-xs text-white/80 mt-0.5">Verify all details before submitting</p>
        </div>
      </div>
      <div class="flex flex-col items-end gap-1">
        <div class="text-xs bg-white/20 px-3 py-1 rounded-full font-medium">
          {{ totalFields }} fields
        </div>
        <div class="text-[10px] text-white/70">{{ summarySections.length }} sections</div>
      </div>
    </div>
  </div>

  <div *ngIf="summarySections.length === 0" class="p-8 text-center bg-white rounded-b-xl">
    <div class="flex flex-col items-center gap-2">
      <div class="flex items-center justify-center w-12 h-12 rounded-full bg-neutral-100">
        <mat-icon class="!text-[24px] !w-6 !h-6 text-neutral-400">description</mat-icon>
      </div>
      <div>
        <p class="text-sm font-semibold text-neutral-700">No Information to Display</p>
        <p class="text-xs text-neutral-500 mt-0.5">Complete the previous steps to see a summary</p>
      </div>
    </div>
  </div>

  <div *ngIf="summarySections.length > 0" class="summary-body p-3  bg-white rounded-b-xl">
    <mat-accordion class="w-full mb-4 mt-4 p-6" [multi]="true">
      <mat-expansion-panel
        *ngFor="let section of summarySections; let sIdx = index; trackBy: trackByIndex"
        [expanded]="sIdx === 0"
        class="!rounded-xl !shadow-none border border-neutral-200 mb-6 mt-6 overflow-hidden p-6"
      >
        <mat-expansion-panel-header class="px-4 py-3 min-h-0">
          <div class="flex items-center w-full gap-3 mt-3">
            <div
              class="flex items-center justify-center w-7 h-7 rounded-full bg-[#1a3a52] text-white text-xs font-bold"
            >
              {{ sIdx + 1 }}
            </div>
            <div class="flex-1 mt-3 mb-3">
              <p class="text-sm font-bold text-[#1a3a52] leading-none">
                {{ section.title }}
              </p>
              <p *ngIf="section.subtitle" class="text-[11px] text-neutral-500">
                {{ section.subtitle }}
              </p>
            </div>
            <div class="flex items-center gap-2"></div>
          </div>
        </mat-expansion-panel-header>

        <div class="p-4 bg-neutral-50">
          <!--  PRIMITIVES GRID  -->
          <div
            *ngIf="section.primitives.length > 0"
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-4"
          >
            <ng-container *ngFor="let item of section.primitives; trackBy: trackByIndex">
              <div class="p-2 rounded-lg border border-neutral-200 bg-white flex flex-col gap-0.5">
                <div class="flex items-center" *ngIf="item.type !== 'file'">
                  <span
                    class="text-[10px] font-semibold text-neutral-600 uppercase tracking-wide truncate"
                    >{{ item.label }}</span
                  >
                </div>
                <div class="text-xs font-medium text-neutral-900 truncate">
                  <!-- FILE -->
                  <div
                    *ngIf="item.type === 'file'"
                    class="flex items-center justify-between gap-1.5"
                    (click)="openFilePreview(item)"
                  >
                    <div class="flex items-center gap-1">
                      <mat-icon class="!text-[11px] !w-3 !h-3 text-neutral-400">{{
                        getIconForType(item.type)
                      }}</mat-icon>
                      <span
                        class="text-[10px] font-semibold text-neutral-600 uppercase tracking-wide truncate max-w-[10ch] text-green-600"
                        >{{ item.label }}</span
                      >
                    </div>
                    <button
                      *ngIf="getFilePreviewData(item)?.base64"
                      type="button"
                      (click)="openFilePreview(item)"
                      class="flex-shrink-0 p-1 text-[#1a3a52] hover:text-[#0f2a45] hover:bg-[#e0e6ef] rounded transition-all duration-200"
                      title="Preview file"
                    >
                      <mat-icon class="!text-[14px] !w-3.5 !h-3.5">visibility</mat-icon>
                    </button>
                  </div>

                  <!-- DATE -->
                  <span *ngIf="item.type === 'date'" class="text-[11px]  font-semibold text-neutral-600">
                    {{ item.value | date:'dd-MMM-yyyy' }}
                  </span>

                  <!-- CHECKBOX -->
                  <span *ngIf="item.type === 'checkbox'" class="inline-flex items-center gap-1">
                    <mat-icon
                      class="!text-[13px] !w-3 !h-3"
                      [class.text-green-600]="item.value === 'Yes'"
                      [class.text-red-600]="item.value === 'No'"
                    >
                      {{ item.value === 'Yes' ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                    <span
                      class="text-[11px] font-semibold"
                      [class.text-green-700]="item.value === 'Yes'"
                      [class.text-red-700]="item.value === 'No'"
                    >
                      {{ item.value | removeUnderscore }}
                    </span>
                  </span>

                  <!-- DEFAULT PRIMITIVE -->
                  <span
                    *ngIf="item.type !== 'file' && item.type !== 'checkbox' && item.type !== 'date'"
                    class="text-neutral-900 block truncate text-sm"
                    [title]="item.value"
                  >
                    {{ item.value | removeUnderscore }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>

          <!--  ARRAY/OBJECT GROUPS  -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <ng-container *ngFor="let group of section.groups; trackBy: trackByIndex">
              <div
                *ngIf="group.items.length > 0"
                class="p-3 rounded-lg border border-blue-300 bg-white"
              >
                <div class="flex items-center gap-2 mb-2">
                  <mat-icon class="!text-[16px] !w-4 !h-4 text-blue-700">person</mat-icon>
                  <h3 class="text-sm font-bold text-blue-800">{{ group.title }}</h3>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <ng-container *ngFor="let item of group.items; trackBy: trackByIndex">
                    <!-- Nested Object -->
                    <div
                      *ngIf="item.type === 'group'"
                      class="col-span-full p-2 rounded-lg border border-[#1a3a52] bg-white"
                    >
                      <div class="flex items-center gap-1.5 mb-1">
                        <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-[#1a3a52]"
                          >pie_chart</mat-icon
                        >
                        <h4 class="text-xs font-bold text-[#1a3a52]">{{ item.label }}</h4>
                      </div>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-1.5">
                        <div
                          *ngFor="let child of item.items; trackBy: trackByIndex"
                          class="flex items-center justify-between gap-2 p-1.5 rounded border border-[#1a3a52] bg-white"
                        >
                          <span class="text-[11px] font-semibold text-[#1a3a52]">{{
                            child.label
                          }}</span>
                          <span class="text-[11px] font-bold text-[#1a3a52]">{{
                            child.value | removeUnderscore
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Primitive Field -->
                    <div
                      *ngIf="item.type !== 'group'"
                      class="p-2 rounded-lg border border-neutral-200 bg-white flex flex-col gap-0.5"
                    >
                      <!-- FILE FIELD IN ARRAY GROUP -->
                      <div *ngIf="item.type === 'file'" class="flex items-center justify-between gap-1.5">
                        <div class="flex items-center gap-1">
                          <mat-icon class="!text-[11px] !w-3 !h-3 text-neutral-400">{{
                            getIconForType(item.type)
                          }}</mat-icon>
                          <span
                            class="text-[10px] font-semibold text-neutral-600 uppercase tracking-wide truncate max-w-[10ch] text-green-600"
                            >{{ item.label }}</span
                          >
                        </div>
                        <button
                          *ngIf="getFilePreviewData(item)?.base64"
                          type="button"
                          (click)="openFilePreview(item)"
                          class="flex-shrink-0 p-1 text-[#1a3a52] hover:text-[#0f2a45] hover:bg-[#e0e6ef] rounded transition-all duration-200"
                          title="Preview file"
                        >
                          <mat-icon class="!text-[14px] !w-3.5 !h-3.5">visibility</mat-icon>
                        </button>
                        <span
                          *ngIf="!getFilePreviewData(item)?.base64 && getFilePreviewData(item)?.attachmentId"
                          class="text-[10px] text-green-600 font-medium"
                        >
                          Uploaded
                        </span>
                        <span
                          *ngIf="!getFilePreviewData(item)"
                          class="text-[10px] text-neutral-400"
                        >
                          No file
                        </span>
                      </div>

                      <!-- NON-FILE FIELD IN ARRAY GROUP -->
                      <div *ngIf="item.type !== 'file'">
                        <div class="flex items-center gap-1">
                          <mat-icon class="!text-[11px] !w-3 !h-3 text-neutral-400">{{
                            getIconForType(item.type)
                          }}</mat-icon>
                          <span
                            class="text-[10px] font-semibold text-neutral-600 uppercase tracking-wide truncate"
                            >{{ item.label }}</span
                          >
                        </div>
                        <div class="text-xs font-medium text-neutral-900 truncate" *ngIf="item.value">
                          {{ item.value | removeUnderscore }}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="mt-4 pt-3 border-t border-neutral-200 flex items-center justify-between gap-3">
      <div class="flex items-center gap-2">
        <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-blue-600">info_outlined</mat-icon>
        <p class="text-[10px] text-neutral-600">
          <span class="font-semibold text-blue-900">Note:</span> If you need to make changes, use the
          "Previous" button to go back and edit any information you entered.
        </p>
      </div>
    </div>
  </div>
</div>

<app-file-preview
  *ngIf="showFilePreview && filePreviewData"
  [file]="filePreviewData"
  [mode]="'modal'"
  [autoOpen]="true"
  (closed)="closeFilePreview()"
></app-file-preview>